import styled from 'styled-components';

export const StatCard = styled.div`
  background: white;
  border-radius: 8px;
  padding: 20px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border: 1px solid oklch(0.838 0.014 312);
`;

export const StatLabel = styled.div`
  font-size: 16px;
  font-family: Calibre-Regular, sans-serif;
  color: rgb(128, 128, 128);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 5px;
`;

export const StatValue = styled.div`
  font-size: 28px;
  font-family: Calibre-Semibold, sans-serif;
  color: rgb(26, 23, 28);
  line-height: 1.2;
`;
